
export const flowsubColumns = [
    // { field: "userId", headerName: "userId", width: 70 },
    {
        field: "version",
        headerName: "version name",
        width: 250,
    },
    {
        field: "active",
        headerName: "active",
        width: 250,
    },
    
];